import { createAction } from '@reduxjs/toolkit';
import { Project, ProjectCreateRequestInput, ProjectUpdateRequestInput } from '@shared/types/project.type';
import { ApiError } from '@app/models/api/api-response.interface';

const createProjectAttempt = createAction<ProjectCreateRequestInput>('[Create Project] Create Project Attempt');

const createProjectSuccess = createAction<{
  projectData: Project;
}>('[Create Project] Create Project Success');

const createProjectFailed = createAction<{ error: ApiError }>('[Create Project] Create Project Failed');

// Action to initiate the update project process
const updateProjectAttempt = createAction<ProjectUpdateRequestInput>('[Update Project] Update Project Attempt');

// Action to handle successful update of a project
const updateProjectSuccess = createAction<{
  projectData: Project;
}>('[Update Project] Update Project Success');

// Action to handle failure during the update project process
const updateProjectFailed = createAction<{ error: ApiError }>('[Update Project] Update Project Failed');

// Action to reset create project state
const resetCreateProjectState = createAction('[Create Project] Reset State');

// Action to set active project (for upload functionality)
const setActiveProject = createAction<{ projectData: Project }>('[Create Project] Set Active Project');

const updateWhitelistDraft = createAction<{
  projectId?: string | null;
  selectedExistingRules: string[];
  existingRulesPayload: Record<
    string,
    {
      setA?: string[];
      setB?: string[];
      regulatory_body?: string[];
      justification?: string;
    }
  >;
  newWhitelistRules: {
    key: string;
    regulatory_body: string[];
    justification: string;
  }[];
}>('[Create Project] Update Whitelist Draft');

export const ProjectCreateActions = {
  createProjectAttempt,
  createProjectSuccess,
  createProjectFailed,
  updateProjectAttempt,
  updateProjectSuccess,
  updateProjectFailed,
  resetCreateProjectState,
  setActiveProject,
  updateWhitelistDraft
};
